import React from 'react';


const VersionSelection = ({ versions, onSelect }) => {
    return (
        <div className="ae-view ae-selection">
            <h2 className="ae-title">원하시는 견적 유형을 선택해주세요</h2>
            <p className="ae-subtitle">고객님의 상황에 맞는 최적의 견적을 도와드립니다.</p>

            <div className="version-grid">
                {versions.map(v => (
                    <div key={v.id} className="version-card clickable" onClick={() => onSelect(v.id)}>
                        <div className="vc-icon">📋</div> {/* Icon placeholder */}
                        <div className="vc-content">
                            <h3 className="vc-title">{v.label || v.name}</h3>
                            {v.description && <p className="vc-desc">{v.description}</p>}
                            {v.totalQuestions > 0 && (
                                <p className="vc-meta" style={{ fontSize: '0.85rem', color: '#666', marginTop: '8px' }}>
                                    ⏱️ 약 {v.estimatedMinutesMin === v.estimatedMinutesMax
                                        ? `${v.estimatedMinutesMin}분`
                                        : `${v.estimatedMinutesMin}~${v.estimatedMinutesMax}분`}
                                    {' '}
                                    ({v.minQuestions === v.totalQuestions
                                        ? `${v.totalQuestions}문항`
                                        : `${v.minQuestions}~${v.totalQuestions}문항`})
                                </p>
                            )}
                        </div>
                        <div className="vc-footer">
                            <button className="select-btn">선택하기</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default VersionSelection;
